import type { SVGProps } from "react";
import { ChartBar } from "lucide-react";

export function InvoiceActivityIcon(props: SVGProps<SVGSVGElement>) {
  return <ChartBar color="currentColor" {...props} className={`w-5 h-5 ${props.className ?? ""}`} />;
}
